import {
  OPTION_FIFTEEN_MIN,
  OPTION_FIVE_MIN,
  OPTION_NOW,
  OPTION_TEN_MIN,
  OPTION_TWENTY_MIN,
} from './constants';

export const options = [
  OPTION_NOW,
  OPTION_FIVE_MIN,
  OPTION_TEN_MIN,
  OPTION_FIFTEEN_MIN,
  OPTION_TWENTY_MIN,
];
